import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const MedicationPendingBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="rounded-tl-lg rounded-tr-none rounded-br-2xl rounded-bl-none border-transparent bg-yellow-500 py-0.5 pr-2 pl-1.5 text-white">
      {t('component:badge.pending')}
    </Badge>
  );
};
